import React, { useEffect, useRef, useState } from "react";
import "../../../assets/css/Hotel.css";
import { useGetCheckoutDetails } from "./hooks/useGetCheckoutDetails";
import { ChevronLeftIcon } from "../../../helper/HwIcon";
import HotelAmountSumary from "./components/HotelAmountSumary.js";
import { HotelDetailsCard } from "./components/HotelDetailsCard.js";
import {
  HotelCheckooutTopTabs,
  tabs,
} from "./components/HotelCheckooutTopTabs.js";
import { HotelCheckoutTabs } from "./HotelCheckoutConstants.js";
import { HotelDetailsTabContent } from "./components/HotelDetailsTabContent.js";
import { Formik } from "formik";
import {
  commonPersonPayload,
  validationSchema,
  validationSchemaReview,
} from "./formUtilts.js";
import { useBookingConfirm } from "./hooks/useBookingConfirm.js";
import StripeWrapper from "../../../component/StripeWrapper";
import { useDownloadPDF } from "../../../hooks/useDownloadPDF.js";
import { useSelector } from "react-redux";
import { addServiceFees, formatPrice, getUserToken } from "../../../helper/commonFunction.js";
import { useLocation } from "react-router-dom";
import { BookingProcessingOverlay } from "../../excursion/checkout/components/BookingProcessingOverlay";
import HotelConfirmSkeleton from "./components/HotelConfirmSkeleton";

const HotelCheckout = () => {
  const formRef = useRef();
  const initialized = useRef(false);
  const routerLocation = useLocation();
  const location = routerLocation.search
  const query = new URLSearchParams(location)
  const commonId = query.get("commonId")

  const [currentTab, setCurrentTab] = useState(
    HotelCheckoutTabs.GUEST_DETAILS
  );

  const { onineServicesFees, onlinePaymentEnable, agentActiveCurrency, displayPrice } = useSelector((state) => state.userData);
  const {
    loading,
    details,
    refresh,
    getBookingDetails,
    setMode,
    priceBreakdown
  } = useGetCheckoutDetails();

  const { loading: downloading, download } = useDownloadPDF();
  const [stripeModalShow, setStripeModalShow] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState({
    value : false,
    touched : false,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (formRef.current && details?._id && !initialized.current) {
      initialized.current = true;

      const roomInfo = details?.apiResponse?.roomInfo ?? [];

      const roomInfoValues = details?.roomDetail?.map((r, i) => {
        const adults = Array(+r?.noOfAdult ?? 0).fill({
          ...commonPersonPayload,
          type: "adults",
        });

        const childs = Array(+r?.noOfChild ?? 0).fill({
          ...commonPersonPayload,
          type: "childs",
        });

        return {
          roomInfo: roomInfo?.[i],
          adults,
          childs,
        };
      });

      formRef?.current?.setFieldValue?.("roomInfoValues", roomInfoValues);
    }
  }, [formRef?.current, details?._id]);

  const basePrice = details?.priceBreakdown?.amount;
  let totalPriceForOnline = basePrice + (parseFloat(basePrice) * parseFloat(onineServicesFees) / 100);
  useEffect(() => {
    if (details?.bookingReference) {
      setCurrentTab(HotelCheckoutTabs.CONFIRM);
      setMode("booking");
    }
  }, [details?.bookingReference, details?.bookingStatus]);

  const {
    doOnlinePayment,
    confirmAfterOnlinePayment,
    doTransaction,
    error,
    loading: booking,
    bookingError
  } = useBookingConfirm(totalPriceForOnline, getBookingDetails, basePrice, onineServicesFees,commonId);

  const onPayNow = (values) => {
    console.log(values, 'values')
    if (values.paymentMethod === "wallet") {
      doTransaction(basePrice, values, details,commonId, () => {
        setMode("booking");
      });
      return;
    }

    if (values.paymentMethod === "online") {
      console.log("Online Payment Clicked")
      setStripeModalShow(true);
    }
  };

  if (loading && !details) {
    return <HotelConfirmSkeleton />;
  }

  return (
    <>
      {booking ? <BookingProcessingOverlay /> : null}
      <div className="hw-stay--div" />

      <div
        className={`hw-hotel--hotelDetails hw-passenger--pageList${
          currentTab === HotelCheckoutTabs.CONFIRM
            ? " hw-passenger--pageListEnd"
            : ""
        } ${booking || loading ? "loader" : ""}`}
        style={(booking || loading) ? {pointerEvents:"none"} : null}
      >
        <HotelCheckooutTopTabs
          currentTab={currentTab}
          activeStep={currentTab}
          bookingId={details?.bookingReference}
          bookingStatus={details?.bookingStatus}
          onBack={() => {
            if (currentTab === HotelCheckoutTabs.GUEST_DETAILS) {
              window.history.back();
            } else if (currentTab === HotelCheckoutTabs.REVIEW) {
              setCurrentTab(HotelCheckoutTabs.GUEST_DETAILS);
            }
          }}
        />

        <div className="hw-page--width">
          <div className="hw-passenger--wrapper">
            <Formik
              innerRef={formRef}
              initialValues={{
                roomInfoValues: [],
                paymentMethod: "wallet",
                bookingReferenceEnabled: true,
                bookingReferenceNote: "",
                contactDetails: {
                  phoneNumber: "",
                  phoneCode: "",
                  email: "",
                },
              }}
              validationSchema={
                currentTab === HotelCheckoutTabs.GUEST_DETAILS
                  ? validationSchema
                  : validationSchemaReview
              }
              onSubmit={(values) => {
                if (currentTab === HotelCheckoutTabs.GUEST_DETAILS) {
                  setCurrentTab(HotelCheckoutTabs.REVIEW);
                } else {
                  if (!acceptTerms?.value) {
                    setAcceptTerms({
                      value: false,
                      touched: true,
                    });
                    return;
                  } else {
                    if (currentTab === HotelCheckoutTabs.REVIEW) {
                      onPayNow(values);
                    }
                  }
                }
              }}
            >
              {({
                values,
                errors,
                touched,
                setFieldValue,
                handleSubmit,
                setTouched,
                validateForm,
              }) => {
                const markAllFieldsTouched = () => {
                  const touchedFields = {
                    roomInfoValues: [],
                    contactDetails: {
                      phoneNumber: true,
                      phoneCode: true,
                      email: true,
                    },
                  };
                  if (values?.roomInfoValues && Array.isArray(values.roomInfoValues)) {
                    values.roomInfoValues.forEach((room, roomIndex) => {
                      const roomTouched = {
                        adults: [],
                        childs: [],
                      };
                      if (room?.adults && Array.isArray(room.adults)) {
                        room.adults.forEach((adult, adultIndex) => {
                          roomTouched.adults[adultIndex] = {
                            gender: true,
                            firstName: true,
                            lastName: true,
                          };
                        });
                      } 
                      if (room?.childs && Array.isArray(room.childs)) {
                        room.childs.forEach((child, childIndex) => {
                          roomTouched.childs[childIndex] = {
                            gender: true,
                            firstName: true,
                            lastName: true,
                          };
                        });
                      }
                      touchedFields.roomInfoValues[roomIndex] = roomTouched;
                    });
                  }
                  setTouched(touchedFields);
                };
                const scrollToFirstError = () => {
                  setTimeout(() => {
                    const container =
                      document.querySelector(".hw-passenger--wrapper") || document;
                    const err = container.querySelector(
                      ".hw-p-error-cls, .hw--error-cls-date-input"
                    );
                    if (!err) return;
                    const field =
                      err.closest(
                        ".col-md-4, .col-md-6, .hw-inner--fullWidth, .hw-passenger--detailsGroup"
                      ) || err;
                    field.scrollIntoView({ behavior: "smooth", block: "center" });
                  }, 80);
                };
                const handleContinue = async () => {
                  const validationErrors = await validateForm();
                  if (Object.keys(validationErrors).length > 0) {
                    markAllFieldsTouched();
                    scrollToFirstError();
                  } else {
                    handleSubmit();
                  }
                };
                
                return (
                <>
                  <div
                    className={`hw-passenger--list ${
                      currentTab === HotelCheckoutTabs.CONFIRM
                        ? "hw-3rd-active-booking-details"
                        : ""
                    }`}
                  >
                    <HotelDetailsTabContent
                      details={details}
                      values={values}
                      errors={errors}
                      touched={touched}
                      setFieldValue={setFieldValue}
                      currentTab={currentTab}
                      hideHotelCard
                      onContinue={handleContinue}
                      onlinePaymentEnable={onlinePaymentEnable}
                      acceptTerms={acceptTerms}
                      setAcceptTerms={setAcceptTerms}
                      download={download}
                      downloading={downloading}
                    />
                  </div>

                  <div className="hw-hotel--asideCol">
                  <HotelDetailsCard details={details} />
                  <HotelAmountSumary
                    currentTab={currentTab}
                    details={details}
                    pricing={details?.priceBreakdown}
                    onContinue={handleContinue}
                    setFieldValue={setFieldValue}
                    error={error}
                    values={values}
                    errors={errors}
                    touched={touched}
                    download={download}
                    booking={booking}
                    bookingError={bookingError}
                    onlinePaymentEnable={onlinePaymentEnable}
                    acceptTerms={acceptTerms}
                    setAcceptTerms={setAcceptTerms}
                  />
                  </div>
                </>
              );
              }}
            </Formik>
          </div>
        </div>
      </div>

      <StripeWrapper
        show={stripeModalShow}
        setShow={setStripeModalShow}
        totalPrice={totalPriceForOnline}
        showDiscounts={true}
        extraChargePrice={{ total: 0 }}
        queryParams={{}}
        bookingOtherData={{}}
        selectPaymentMethod={1}
        onineServicesFees={0}
        agentActiveCurrency={agentActiveCurrency || 'AED'}
        displayPrice={displayPrice}
        onPaymentSuccess={async (paymentMethod) => {
          await confirmAfterOnlinePayment(formRef?.current?.values, details, onineServicesFees, paymentMethod , totalPriceForOnline, basePrice,setMode);
          setStripeModalShow(false);
        }}
        onClose={() => {
          setStripeModalShow(false);
        }}
      />
    </>
  );
};

export default HotelCheckout;
